<template>
    <div class="grid grid-cols-1 gap-4">
        <div
            v-for="(item, index) in permissions"
            :key="index">
            <hts-form-disclosure
                color="main"
                size="large"
                :is-have-children="item.children ? true : false">
                <template #reference>
                    <div class="flex items-center gap-3">
                        <input
                            type="checkbox"
                            class="w-[17.5px] h-[17.5px]"
                            :indeterminate="dataGroupPermissions.includes(item.permissionKey) && checkIndeterminate(item)"
                            :checked="dataGroupPermissions.includes(item.permissionKey) || isAdmin"
                            :value="item.permissionKey"
                            :disabled="isAdmin"
                            @click="(e) => actionCheckbox(e, item, !dataGroupPermissions.includes(item.permissionKey))" >
                        <span>
                            {{ $t(item.label) }}
                        </span>
                    </div>
                </template>
                <template #children>
                    <div
                        v-for="(childItem, subIndex) in item.children"
                        :key="subIndex">
                        <div
                            v-if="childItem.children"
                            class="rounded-lg text-white mt-3 ml-10">
                            <recursive-component
                                :permissions="[childItem]"
                                :action-checkbox="actionCheckbox"
                                :action-sub-checkbox="actionSubCheckbox"
                                :data-group-permissions="dataGroupPermissions"
                                :is-admin="isAdmin" />
                        </div>
                        <div
                            v-else
                            :class="[!childItem.isDisabled ? 'bg-main-500' : 'bg-main-300']"
                            class="flex align-middle items-center gap-3 h-10 rounded-lg text-white mt-3 ml-10 p-2 pl-3 hover:bg-main-600">
                            <input
                                type="checkbox"
                                class="w-[17.5px] h-[17.5px]"
                                :disabled="(childItem.isDisabled ? true : false) || isAdmin"
                                :checked="dataGroupPermissions.includes(childItem.permissionKey) || isAdmin"
                                :value="childItem.permissionKey"
                                @change="(e) => actionSubCheckbox(e, childItem.permissionKey)" >
                            <div>
                                <span>
                                    {{ $t(childItem.label) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </template>
            </hts-form-disclosure>
        </div>
    </div>
</template>
<script setup lang="ts">
import RecursiveComponent from './permission-checkbox.vue'
const props = defineProps({
  permissions: {
    type: Object,
    required: true
  },
  actionCheckbox: {
    type: Function,
    required: true
  },
  actionSubCheckbox: {
    type: Function,
    required: true
  },
  dataGroupPermissions: {
    type: Array,
    required: true
  },
  isAdmin: {
    type: Boolean,
    default: false
  }
})

const { permissions, actionCheckbox, actionSubCheckbox, dataGroupPermissions } = toRefs(props)

const checkIndeterminate = (item: any) => {
  if (!item.children) {
    return
  }
  const result = item.children.map((chil: any) => {
    if (chil.children) {
      return checkIndeterminate(chil)
    }
    if (!dataGroupPermissions.value.includes(chil.permissionKey)) {
      return true
    }
    return false
  })
  if (result.includes(true)) {
    return true
  }
  return false
}
</script>
